(() => {
  if (window.KleryaHomeHeader) return;
  window.KleryaHomeHeader = true;

  const solidClass = 'klerya-header-solid';
  let activeHero = null;
  let ticking = false;

  const findHero = () => document.querySelector('.template-index .section-klerya-hero');

  const updateHeaderState = () => {
    ticking = false;
    activeHero = findHero();

    if (!activeHero || !document.body.classList.contains('template-index')) {
      document.body.classList.remove(solidClass);
      return;
    }

    const heroTop = activeHero.getBoundingClientRect().top + window.scrollY;
    const heroMiddle = heroTop + activeHero.offsetHeight / 2;
    document.body.classList.toggle(solidClass, window.scrollY >= heroMiddle);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderState);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:unload', requestUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderState, { once: true });
  } else {
    updateHeaderState();
  }
})();
